import React, { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";

function EAU({ devices }) {
  const [selectedDevice, setSelectedDevice] = useState("all");

  const handleDeviceChange = (event) => {
    setSelectedDevice(event.target.value);
  };

  const filteredDevices =
    selectedDevice === "all"
      ? devices
      : devices.filter((device) => device.dCore === selectedDevice);

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>🔧 EAU Device Management</h1>

      {/* Dropdown for selecting device */}
      <div style={{ marginBottom: "20px" }}>
        <label htmlFor="device-select" style={{ marginRight: "10px", fontWeight: "bold" }}>
          Select Device:
        </label>
        <select id="device-select" value={selectedDevice} onChange={handleDeviceChange}>
          <option value="all">All Devices</option>
          {[...new Set(devices.map((device) => device.dCore))].map((uniqueDCore) => (
            <option key={uniqueDCore} value={uniqueDCore}>
              {uniqueDCore}
            </option>
          ))}
        </select>
      </div>

      {/* Device Cards */}
      {filteredDevices.map((device, index) => (
        <div key={index} style={styles.deviceCard}>
          {/* Device Info */}
          <div style={styles.deviceInfo}>
            <p><strong>🆔 Device ID:</strong> {device.dCore}</p>
            <p><strong>⏱ Test Start Time:</strong> {new Date(device.timestamp).toLocaleString()}</p>
            {device.progress === "Complete" && device.endTime && (
              <p><strong>⏱ Test End Time:</strong> {new Date(device.endTime).toLocaleString()}</p>
            )}
            <p>
              <strong>📡 Test Status:</strong>{" "}
              <span style={{ color: device.testStatus.toLowerCase() === "active" ? "green" : "black" }}>
                {device.testStatus}
              </span>
            </p>
            {device.lowCount !== undefined && (<p><strong>🆔 Low Count:</strong> {device.lowCount}</p>)}
            {device.eVoiceNumber !== undefined && (<p><strong> Message:</strong> {device.eVoiceMessage}</p>)}
            <p><strong>📅 Progress:</strong> {device.progress}</p>
            <p><strong>⏱ Bacteria Result:</strong> {device.bacteriaResult}</p>
            <ul style={styles.dataList}>
              {device.eLuxDataValues.map((data, dataIndex) => (
                <li key={dataIndex} style={styles.dataItem}>
                  <strong>{dataIndex + 1}.</strong>{" "}
                  Time: {data.timestamp ? new Date(data.timestamp).toLocaleTimeString() : "Invalid"} |{" "}
                  EAU: {device.EAUValues ? device.EAUValues[dataIndex] : "N/A"}
                </li>
              ))}
            </ul>
          </div>

          {/* Graph Section */}
          <div style={styles.graphContainer}>
            <h3 style={styles.graphTitle}>📊 EAU Graph</h3>
            <ResponsiveContainer width="100%" height={300}>
              <LineChart
                data={device.eLuxDataValues.map((d, index) => {
                  let timestamp = d.timestamp;
                  if (timestamp && timestamp.$date) timestamp = timestamp.$date;

                  return {
                    time: timestamp ? new Date(timestamp).toLocaleTimeString() : "Invalid",
                    eau: device.EAUValues ? device.EAUValues[index] : null,
                  };
                })}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="time" />
                <YAxis />
                <Tooltip />
                <Line type="monotone" dataKey="eau" stroke="#007bff" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      ))}
    </div>
  );
}

const styles = {
  container: {
    width: "90%",
    margin: "auto",
    textAlign: "center",
    padding: "20px",
    background: "#f8f9fa",
    borderRadius: "10px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  },
  heading: {
    fontSize: "28px",
    color: "#333",
    marginBottom: "20px",
  },
  deviceCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "white",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
    marginBottom: "20px",
    borderLeft: "5px solid #007bff",
  },
  deviceInfo: {
    flex: 1,
    textAlign: "left",
    paddingRight: "20px",
  },
  dataList: {
    listStyle: "none",
    padding: 0,
  },
  dataItem: {
    fontSize: "16px",
    background: "#eef5ff",
    padding: "5px 10px",
    borderRadius: "5px",
    margin: "5px 0",
  },
  graphContainer: {
    flex: 2,
    minWidth: "400px",
  },
  graphTitle: {
    fontSize: "18px",
    color: "#007bff",
    marginBottom: "10px",
  },
};

export default EAU;
